var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import ServiceDeliveryLocationService from "../../../Services/ServiceDeliveryLocation.service";
const makeSearchArgs = {
    loadOptions: (search, options) => __awaiter(void 0, void 0, void 0, function* () {
        if (options.forceEmptyReturn) {
            return [];
        }
        return ServiceDeliveryLocationService.search({
            query: search,
            ids: options.ids,
            excludeIds: options.excludeIds,
            active: options.active,
            locationIds: options.locationIds,
            allowSelfServiceCheckIn: options.allowSelfServiceCheckIn,
            selfServiceStaffPersonIds: options.selfServiceStaffPersonIds,
            showInLegacyScheduler: options.showInLegacyScheduler,
            showInNewScheduler: options.showInNewScheduler,
        }, {
            max: 20,
        }).then((res) => res.data);
    }),
    label: "name",
    value: "id",
};
export const ServiceDeliveryLocationSearch = makeSearch(makeSearchArgs);
export const ServiceDeliveryLocationMultiSearch = makeMultiSearch(makeSearchArgs);
